import { FaUsers } from "react-icons/fa";
import { IoCheckbox } from "react-icons/io5";

import { ImExit } from "react-icons/im";
import { FaSquareXmark } from "react-icons/fa6";

export const navData = [
  {
    label: "Total Staff",
    bgColor: "bg-white",
    textColor: "text-purple-700",
    icon: <FaUsers className="text-[#564FFD]" />,
    iconColor: "text-[#564FFD]",
  },
  {
    label: "Present Today",
    // url: "/teachers",
    bgColor: "bg-white",
    textColor: "text-green-700",
    icon: <IoCheckbox className="text-[#22c55e]" />,
    iconColor: "text-green",
  },
  {
    label: "Absent Today",
    bgColor: "bg-white",
    textColor: "black",
    icon: <FaSquareXmark className="text-[#EA2058]" />,
    iconColor: "text-[#F09F04]",
  },
  {
    label: "Leave Today",
    bgColor: "bg-white",
    textColor: "text-pink-700",
    icon: <ImExit className="text-[#EA2058]" />,
    iconColor: "text-[#EA2058]",
  },
];
